<div class="inicio">
    <p class="titulo">
        ASIGNACIÓN EQUIPO DE ESCRITORIO
        <button mat-mini-fab color="primary" matTooltip="Click para más información"
            (click)="clickMasInformacion($event)">
            <mat-icon>info</mat-icon>
        </button>
    </p>

    <div>
        <!--<div class="encabezado_botones">-->
        <div class="example-button-row">
            <div class="selector-dispositivo" [ngClass]="{'selector-dispositivo-selected': indice === 1}">
                <button mat-mini-fab [color]="cpuFormulario?.value.id ? 'accent' : 'primary'" (click)="cargarTabla(1)"
                    matTooltip="Este botón carga todas las cpu's disponibles."> <mat-icon>computer </mat-icon> </button>
            </div>
            <div class="selector-dispositivo" [ngClass]="{'selector-dispositivo-selected': indice === 2}">
                <button mat-mini-fab [color]="monitorFormulario?.value.id ? 'accent' : 'primary'"
                    (click)="cargarTabla(2)" matTooltip="Este botón carga todas ls monitores disponibles.">
                    <mat-icon>desktop_windows</mat-icon>
                </button>
            </div>
            <div class="selector-dispositivo" [ngClass]="{'selector-dispositivo-selected': indice === 3}">
                <button mat-mini-fab [color]="tecladoFormulario?.value.id ? 'accent' : 'primary'"
                    (click)="cargarTabla(3)" matTooltip="Este botón carga todos los teclados disponibles.">
                    <mat-icon>keyboard </mat-icon>
                </button>
            </div>
            <div class="selector-dispositivo" [ngClass]="{'selector-dispositivo-selected': indice === 4}">
                <button mat-mini-fab [color]="mouseFormulario?.value.id ? 'accent' : 'primary'" (click)="cargarTabla(4)"
                    matTooltip="Este botón carga todos los mouse's disponibles."> <mat-icon>mouse </mat-icon> </button>
            </div>
            <div class="selector-dispositivo" [ngClass]="{'selector-dispositivo-selected': indice === 5}">
                <button mat-mini-fab [color]="reguladorFormulario?.value.id ? 'accent' : 'primary'"
                    (click)="cargarTabla(5)" matTooltip="Este botón carga todos los reguladores disponibles.">
                    <mat-icon>power </mat-icon>
                </button>
            </div>
        </div>
        <p>TABLA: {{nombreTabla}}</p>
        <div>
            <mat-form-field appearance="fill">
                <input matInput #buscador (keyup)="filtroDataSource($event)" placeholder="Buscar dispositivo">
            </mat-form-field>

            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

                <ng-container matColumnDef="OPCIONES">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> OPCIONES </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-mini-fab color="primary" (click)="seleccionarEquipo(element.name,element.id)"
                            matTooltip="Al dar click estarás seleccionando este equipo">
                            <mat-icon>check_circle</mat-icon> </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="NOMBRE">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE </th>
                    <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                </ng-container>

                <ng-container matColumnDef="NÚMERO DE SERIE">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> NÚMERO DE SERIE </th>
                    <td mat-cell *matCellDef="let element"> {{element.serial}} </td>
                </ng-container>

                <ng-container matColumnDef="TIPO">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> TIPO </th>
                    <td mat-cell *matCellDef="let element"> {{element.tipo}} </td>
                </ng-container>

                <ng-container matColumnDef="MODELO">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> MODELO </th>
                    <td mat-cell *matCellDef="let element"> {{element.modelo}} </td>
                </ng-container>

                <ng-container matColumnDef="FABRICANTE">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> FABRICANTE </th>
                    <td mat-cell *matCellDef="let element"> {{element.manufacturers_id}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="encabezados"></tr>
                <tr mat-row *matRowDef="let row; columns: encabezados;"></tr>

            </table>
            <mat-paginator class="mat-elevation-z8" [pageSizeOptions]="[7, 20, 30, 40, 50]"
                showFirstLastButtons></mat-paginator>
        </div>
    </div>



    <form [formGroup]="formularioDispositivos">
        <div class="columnas3">
            <div class="celda_label" formGroupName="cpu">
                <mat-label>
                    <mat-label class="negrita">CPU: </mat-label>
                    <mat-label class="texto">{{ cpuFormulario?.value.nombre }}</mat-label>
                </mat-label>
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Observaciones</mat-label>
                    <input matInput formControlName="observaciones">
                </mat-form-field>
            </div>

            <div class="celda_label" formGroupName="monitor">
                <mat-label>
                    <mat-label class="negrita">MONITOR: </mat-label>
                    <mat-label class="texto">{{ monitorFormulario?.value.nombre }}</mat-label>
                </mat-label>
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Observaciones</mat-label>
                    <input matInput formControlName="observaciones">
                </mat-form-field>
            </div>

            <div class="celda_label" formGroupName="teclado">
                <mat-label>
                    <mat-label class="negrita">TECLADO: </mat-label>
                    <mat-label class="texto">{{ tecladoFormulario?.value.nombre }}</mat-label>
                </mat-label>
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Observaciones</mat-label>
                    <input matInput formControlName="observaciones">
                </mat-form-field>
            </div>

            <div class="celda_label" formGroupName="mouse">
                <mat-label>
                    <mat-label class="negrita">MOUSE: </mat-label>
                    <mat-label class="texto">{{ mouseFormulario?.value.nombre }}</mat-label>
                </mat-label>
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Observaciones</mat-label>
                    <input matInput formControlName="observaciones">
                </mat-form-field>
            </div>

            <div class="celda_label" formGroupName="regulador">
                <mat-label>
                    <mat-label class="negrita">REGULADOR: </mat-label>
                    <mat-label class="texto">{{ reguladorFormulario?.value.nombre }}</mat-label>
                    <button mat-icon-button color="warn" aria-label="Quitar regulador"
                        *ngIf="reguladorFormulario?.get('id')?.value" (click)="quitarRegulador()">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-label>
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Observaciones</mat-label>
                    <input matInput formControlName="observaciones">
                </mat-form-field>
            </div>

            <div class="botones_Cancelar_Guardar">
                <div class="example-button-row">
                    <button mat-raised-button color="primary"
                        matTooltip="Inicias la asignación de esta computadora de escritorio."
                        [disabled]="formularioDispositivos.invalid" (click)="asignar()">Asignar </button>
                    <button mat-raised-button color="warn"
                        matTooltip="Cancelas la asignación de esta computadora de escritorio." (click)="cancelar()">
                        Cancelar</button>
                </div>
            </div>
        </div>
    </form>

</div>